import OspreyUsersSearch from './usersSearch'

export default class Users {

    search(dataKey) {
        return new OspreyUsersSearch(dataKey)
    }

}



// WEBPACK FOOTER //
// src/actions/osprey-api/users/index.js